import { atom } from 'recoil';

export const dataFormCommerceFinishBene = atom({
  key: 'dataFormCommerceFinishBene',
  default: undefined,
});
